export const viewTitle = "Список фондов";
export const viewUniqKey = "fundsListReport";
